import {ProductSummary} from "./product/ProductSummary";

export interface IResearchPagination {
    pageIndex: number;
    pageSize: number;
}

export const DEFAULT_RESEARCH_PAGINATION: IResearchPagination = {pageIndex: 0, pageSize: 50};

export type FacetedFilters = Record<string, Set<string>>;

export interface IResearchPageState {
    facetedFilters: FacetedFilters;
    searchText: string;
    pagination: IResearchPagination;
    scrollToBackstopId: number | undefined;
}

export interface DisplayProductSummary extends ProductSummary {
    managerName: string;
    oddRatingCurrent: string;
}

export const FILTER_FIELD_LABELS: Record<string, string> = {
    assetType: "research-page.asset-class",
    productRating: "research-page.rating",
    oddRatingCurrent: "research-page.odd-rating",
    approach: "research-page.approach",
    category: "research-page.category",
    region: "research-page.region",
    style: "research-page.style",
};

export const FILTER_FIELD_DEFAULTS: Record<string, string> = {
    assetType: "Asset Class",
    productRating: "Rating",
    oddRatingCurrent: "ODD Rating",
    approach: "Approach",
    category: "Category",
    region: "Region",
    style: "Style",
};
